import dayjs from 'dayjs'

/**
 * Sorts an array alphabetically
 * @param {any[]} arr. An array of strings, or an array with objects.
 * @param {string} key. For an array of objects, pas the key to sort on.
 * @param {string} local. Pass the local option for the localeCompare.
 * @param {boolean} numeric. Indicate if the string data contains numbers
 */
export const sortAlphabetical = (arr: any[] = [], key?: string, local: string = 'en', numeric: boolean = true) =>
  arr.sort((a, b) => (key ? a[key] : a).localeCompare(key ? b[key] : b, local, { numeric }))

/**
 * Sorts an array by date
 * @param {any[]} arr. An array of strings, or an array with objects.
 * @param {string} key. For an array of objects, pas the key to sort on.
 */
export const sortByDate = (arr: any[] = [], key?: string) => {
  return arr.sort((a, b) => dayjs(key ? b[key] : b).diff(key ? a[key] : a))
}
